<template>
  <div>
    <v-popover
      v-if="isKeywordOverflowing"
      placement="top"
      trigger="hover"
      popoverClass="keyword__tooltip"
      :delay="{ show: 500, hide: 200 }"
    >
      <div class="keyword" :class="{ 'is-result': isResult }">
        <BaseIcon v-if="!isResult" name="arrow-right" class="arrow" />
        <span :ref="'keywordContent'" v-html="keyword">{{ keyword }} </span>
      </div>
      <template v-slot:popover>
        <div class="keyword__tooltip-content">
          <span :ref="'keywordContent'" v-html="keyword">{{ keyword }} </span>
        </div>
      </template>
    </v-popover>
    <div v-else class="keyword" :class="{ 'is-result': isResult }">
      <BaseIcon v-if="!isResult" name="arrow-right" class="arrow" />
      <span :ref="'keywordContent'" v-html="keyword">{{ keyword }} </span>
    </div>
  </div>
</template>

<script>
import BaseIcon from '@/components/base/BaseIcon';
import { highlightKeywordSyntax } from '@/util/keyword-syntax-highlight';

export default {
  name: 'Keyword',
  beforeMount() {
    this.prepare();
  },
  beforeUpdate() {
    this.prepare();
  },
  props: {
    isResult: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BaseIcon,
  },
  data() {
    return {
      isKeywordOverflowing: false,
    };
  },
  computed: {
    keyword() {
      return highlightKeywordSyntax(this.text);
    },
  },
  methods: {
    prepare() {
      const defaultSlot = this.$slots.default;

      if (!defaultSlot) {
        this.text = '';
      } else if (defaultSlot[0].tag !== undefined) {
        this.text = '';
      } else {
        this.text = defaultSlot[0].text;
      }
    },
  },
  mounted() {
    const keywordElement = this.$refs['keywordContent'];
    if (keywordElement) {
      this.isKeywordOverflowing = keywordElement.offsetWidth < keywordElement.scrollWidth;
    }
  },
};
</script>

<style lang="scss">
.arrow {
  color: $color-accent;
  margin-right: 2px;
  margin-top: 1px;
  height: 16px;
  padding-bottom: 2px;
}

.keyword {
  align-items: center;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 800px;
  font-size: $font-size-small;
  max-width: max-content;
  padding: 2px 4px;
  border-radius: $border-radius-small;

  &.is-result {
    background: $color-highlight;
  }

  &__tooltip {
    min-width: max-content;
    padding: 8px;
    font-size: $font-size-small;
    text-align: start;
    background-color: $color-normal !important;
    color: $color-white !important;
    box-shadow: $shadow-tooltip;

    .popover-arrow {
      background-color: $color-normal !important;
    }
  }

  span {
    max-width: 200px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  @media screen and (max-width: 784px) {
    max-width: 100%;
  }

  // Phones: the whole keyword, on as many lines as it takes; there is no hover to show the rest.
  @include screen-below('tablet') {
    align-items: flex-start;
    white-space: normal;

    span {
      max-width: none;
      overflow: visible;
      white-space: normal;
      overflow-wrap: anywhere;
    }
  }
}
</style>
